export default __webpack_public_path__ + "static/media/monika.d431bd9b.jpg";